export interface ParsedRoute {
  pageType: PageType;
}

export type PageType =
  | "home"
  | "collection"
  | "product"
  | "page"
  | "account"
  | "challenge"
  | "blog"
  | "cart"
  | "search"
  | "wishlist"
  | "unknown";

export interface RouteParams {
  locale?: string;
  page?: string;
  collection?: string;
  product?: string;
  account?: string;
  blog?: string;
  cart?: string;
}

export interface RouteTest {
  pageType: PageType;
  match: (path: string, params: { wishlistUrl: string }) => boolean;
}

const tests: Array<RouteTest> = [
  {
    pageType: "product",
    match: (path: string) => path.includes("/products/"),
  },
  {
    pageType: "collection",
    match: (path: string) =>
      path.includes("/collections/") && !path.includes("/products/"),
  },
  {
    pageType: "account",
    match: (path: string) =>
      path.includes("/account/") || path.endsWith("/account"),
  },
  {
    pageType: "challenge",
    match: (path: string) => path.endsWith("/account"),
  },
  {
    pageType: "blog",
    match: (path: string) => path.includes("/blog/"),
  },
  {
    pageType: "cart",
    match: (path: string) => path.includes("/cart/") || path.endsWith("/cart"),
  },
  {
    pageType: "wishlist",
    match: (path: string, { wishlistUrl }) => path.includes(wishlistUrl),
  },
  {
    pageType: "page",
    match: (path: string) => path.includes("/pages/"),
  },
  {
    pageType: "search",
    match: (path: string) => path.includes("/search"),
  },
  {
    pageType: "home",
    match: (path: string) => path.length < 4,
  },
];

export class RouteUtil {
  wishlistUrl: string;

  constructor({ wishlistUrl }: { wishlistUrl: string }) {
    this.wishlistUrl = wishlistUrl;
  }

  parse(path: string): ParsedRoute {
    for (const test of tests) {
      const match = test.match(path, { wishlistUrl: this.wishlistUrl });
      if (match) {
        return {
          pageType: test.pageType,
        };
      }
    }

    return {
      pageType: "unknown",
    };
  }
}
